import React, {
  ChangeEvent,
  memo,
  MouseEvent,
  useCallback,
  useEffect,
  useState,
} from "react"
import { useHistory } from "react-router-dom"

import {
  useHandleMessagesContext,
  useMessagesContext,
  useSchedule,
} from "@shared/contexts"
import { getRequiredQuery } from "@shared/modules"

interface Props {
  isChatMode?: boolean
}

function Search({ isChatMode }: Props) {
  const history = useHistory()
  const { schedule } = useSchedule()
  const { keyword, positions } = useMessagesContext()
  const { search } = useHandleMessagesContext()

  const [searchKeyword, setSearchKeyword] = useState<string>(
    keyword ? keyword : "",
  )

  const getSearchPath = useCallback(
    (path: string) => {
      const middleLocation = isChatMode ? "chat-mode/search" : "search"
      return `/${schedule!.user!.username}/${
        schedule!.id
      }/${middleLocation}/${path}${getRequiredQuery()}`
    },
    [isChatMode, schedule],
  )

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    e.preventDefault()

    history.push(getSearchPath(e.target.value))
  }

  const getSearch = () => {
    if (searchKeyword.length <= 0) {
      alert("검색어를 입력 해주세요")
      return
    }

    search(searchKeyword)
  }

  useEffect(() => {
    if (positions.length <= 0) return

    const [first] = positions

    history.push(getSearchPath(first))
  }, [positions, getSearchPath, history])

  return (
    <div className="searchB">
      <div className={`${isChatMode ? "txt" : "inner"}`}>
        <input
          type="text"
          onChange={(e) => {
            setSearchKeyword(e.target.value)
          }}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              getSearch()
            }
          }}
          value={searchKeyword}
          placeholder="검색어를 입력하세요."
        />
        <a
          href="#!"
          title="검색"
          onClick={(e: MouseEvent) => {
            e.preventDefault()
            getSearch()
          }}
        >
          검색
        </a>

        {positions.length > 0 ? (
          <select onChange={handleChange}>
            {positions.map((position, i) => (
              <option key={i} value={position}>
                {i + 1}/{positions.length}
              </option>
            ))}
          </select>
        ) : (
          <select disabled={true}>
            <option>0/0</option>
          </select>
        )}
      </div>
    </div>
  )
}

export default memo(Search)
